var React = require('react');

function KudaSendInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.7","cx":"12.5","cy":"13","r":"12.5","fill":"#DCFFEC","key":0}),React.createElement("path",{"d":"M14.9913 10.5088L11.2674 13.3713L7.625 11.8936L17.375 8.125L13.6064 17.875L12.1287 14.2325L14.9913 10.5088Z","fill":"#48D38A","key":1})]);
}

KudaSendInline.defaultProps = {"width":"25","height":"26","viewBox":"0 0 25 26","fill":"none"};

module.exports = KudaSendInline;

KudaSendInline.default = KudaSendInline;
